import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { Avatar, Paper, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: 12,
  },
  content: {
    marginTop: 8,
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  link: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  avatar: {
    marginRight: 12,
    height: 48,
    width: 48,
  },
}))

function AvatarInfo(props) {
  const { classes, cx } = useStyles()

  const LinkWrapper = props.route ? Link : Fragment

  return (
    <Paper className={cx(props.className, classes.container)}>
      <LinkWrapper
        className={classes.link}
        style={{ textDecoration: 'none' }}
        to={props.route}
      >
        <Typography variant='button'>{props.title}</Typography>
        <div className={classes.content}>
          <Avatar
            alt={props.name}
            className={classes.avatar}
            src={props.avatarSrc}
          >
            {props.icon ? props.icon : props.name.match(/\b(\w)/g).join('')}
          </Avatar>
          <div>
            <Typography variant='subtitle1'>{props.name}</Typography>
            {props.email && (
              <Typography variant='body2'>{props.email}</Typography>
            )}
          </div>
        </div>
      </LinkWrapper>
    </Paper>
  )
}

AvatarInfo.propTypes = {
  route: PropTypes.string,
  title: PropTypes.string,
  name: PropTypes.string,
  avatarSrc: PropTypes.string,
  icon: PropTypes.element,
  email: PropTypes.string,
}

export default AvatarInfo
